import { generateKeys, generateLocalization } from '../utils';
export const errors = generateKeys({
    campaignDoesNotExist: {
        label: 'Campaign ${campaignId} does not exist.',
    },
    bannerDoesNotExist: {
        label: 'Banner ${bannerId} does not exist.',
    },
    clientDoesNotExist: {
        label: 'Client ${clientId} does not exist.',
    },
    permissionDenied: {
        label: 'Logged user does not have right to see this page.',
    },
});
export const passwordErrors = generateLocalization('passwordErrors', generateKeys({
    isRequired: {
        message: 'Password is required',
        label: 'Field is required!',
        localization: { id: '', defaultMessage: '' },
    },
    isLessThan5Chars: {
        message: 'Password must have at least 5 characters',
        label: 'Password length has to be between 5 to 15 characters.',
        localization: { id: '', defaultMessage: '' },
    },
    isMoreThan15Chars: {
        message: 'Password may have at most 15 characters',
        label: 'Password length has to be between 5 to 15 characters.',
        localization: { id: '', defaultMessage: '' },
    },
    noLowerCaseLetter: {
        message: 'Password must contain at least one lower case letter',
        label: 'Password must contain at least one lower case letter, one upper case letter and one digit.',
        localization: { id: '', defaultMessage: '' },
    },
    noUpperCaseLetter: {
        message: 'Password must contain at least one upper case letter',
        label: 'Password must contain at least one lower case letter, one upper case letter and one digit.',
        localization: { id: '', defaultMessage: '' },
    },
    noAnyLetter: {
        message: 'Password must contain at least one letter',
        label: 'Password must contain at least one letter.',
        localization: { id: '', defaultMessage: '' },
    },
    noDigit: {
        message: 'Password must contain at least one digit',
        label: 'Password must contain at least one digit.',
        localization: { id: '', defaultMessage: '' },
    },
    noSpecialCharacter: {
        message: 'Password must contain at least one special character.',
        label: 'Password must contain at least one special character.',
        localization: { id: '', defaultMessage: '' },
    },
    isLessThan8Chars: {
        message: 'Password must have at least 8 characters',
        label: 'Password length has to be between 8 to 15 characters.',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const apiErrors = generateLocalization('apiErrors', generateKeys({
    BDErrorInvalidCredentials: {
        label: 'The credentials that you are using are incorrect, please ensure that you are using the correct password and email combination.',
        localization: { id: '', defaultMessage: '' },
    },
    BDErrorAccountClosed: {
        label: 'Your account was closed. Please contact support.',
        localization: { id: '', defaultMessage: '' },
    },
    BDErrorInvalidSocialCredentials: {
        label: 'Invalid account.',
        localization: { id: '', defaultMessage: '' },
    },
    BDErrorSocialAccountExists: {
        label: 'Account already exists.',
        localization: { id: '', defaultMessage: '' },
    },
    BDUnauthorizedAccess: {
        label: 'Unauthorized Access',
        localization: { id: '', defaultMessage: '' },
    },
    BDValidationError: {
        label: 'Validation Error',
        localization: { id: '', defaultMessage: '' },
    },
    BDDepositError: {
        label: 'Deposit Error',
        localization: { id: '', defaultMessage: '' },
    },
    BDInvalidCardTokenError: {
        label: 'Invalid card token',
        localization: { id: '', defaultMessage: '' },
    },
    BDGeneralError: {
        label: 'General Error',
        localization: { id: '', defaultMessage: '' },
    },
    BDCorporateNotSupported: {
        label: 'Sorry, corporate users are not supported by this app',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const openTradeErrors = generateLocalization('openTradeErrors', generateKeys({
    invalidAccountId: {
        message: 'Invalid account id',
        label: 'Invalid account id',
        localization: { id: '', defaultMessage: '' },
    },
    unableToOpenTrade: {
        message: 'Unable to open trade',
        label: 'Unable to open trade',
        localization: { id: '', defaultMessage: '' },
    },
}));
